import React from "react";
import { useTranslation } from "react-i18next";
import PersianPrice from "../Header/PersianPrice";

const InvoiceDetailsTotal = ({ detailData, classes }) => {
  const { discount, orders, vat, total } = detailData;
  const { t, i18n } = useTranslation();

  const calcInvoicesPrice = () => {
    let result = 0;
    orders.map((item, index) => {
      result += item.total;
    });
    return Math.floor(result);
  };

  return (
    <div className="w-100 p-2 d-flex justify-content-end">
      <div
        style={{
          display: "flex",
          width: "fit-content",
          backgroundColor: "rgba(0, 150, 136,0.1)",
          borderRadius: " 0.6em",
        }}
        className="col col-md-3 col-lg-3 col-xs-12 col-sm-12 w-100 p-2 d-flex flex-column align-items-center justify-content-end"
      >
        <div className="w-100 d-flex justify-content-between">
          <div>
            <p
              className={`${i18n.dir() === "rtl" ? "text-left" : "text-right"}`}
            >
              {t("invoices.total_invoice_amounts")}
            </p>
            <p
              className={`${i18n.dir() === "rtl" ? "text-left" : "text-right"}`}
            >
              {t("invoices.discount")}
            </p>
            <p
              className={`${i18n.dir() === "rtl" ? "text-left" : "text-right"}`}
            >
              {t("invoices.gift")}
            </p>
            <p
              className={`${i18n.dir() === "rtl" ? "text-left" : "text-right"}`}
            >
              {t("invoices.value_Added")}
            </p>
          </div>
          <div>
            <p>
              <PersianPrice number={calcInvoicesPrice()} />
            </p>
            <p>
              <PersianPrice number={discount} />
            </p>
            <p>
              <PersianPrice number={0} />
            </p>
            <p>
              <PersianPrice number={Math.floor(vat)} />
            </p>
          </div>
        </div>
        <hr
          style={{
            width: "95%",
            borderBottom: "1px solid rgba(0,186,186,1)",
            margin: "10px 0",
          }}
        />
        <div
          style={{ color: "rgba(0, 186, 186, 1)" }}
          className="w-100 d-flex justify-content-between"
        >
          <div>
            <p>{t("invoices.final_amount")}</p>
          </div>
          <div>
            <p>
              <PersianPrice number={Math.floor(total)} />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetailsTotal;
